import React from 'react';
import classnames from 'classnames';

import { VODCSSModules } from 'shared/utils/wix-connect';

import { GenericButton } from '../button';
import PropTypes from 'prop-types';
import Icon from 'shared/components/icon/icon';
import withTooltip, { adaptShowStatePropsToClassName } from 'shared/components/with-tooltip/with-tooltip';

import styles from './icon.styl';


@VODCSSModules(styles)
export default class IconButton extends React.Component {

  static propTypes = {
    Button: PropTypes.func,
    name: PropTypes.string,
    size: PropTypes.number,
    label: PropTypes.any,
    children: PropTypes.any,
    className: PropTypes.string,
    dataHook: PropTypes.string,
    iconClassName: PropTypes.string,
  };

  static defaultProps = {
    Button: GenericButton,
  };

  get label() {
    const { label, children } = this.props;
    const text = _.isUndefined(label) ? children : label;

    if (!text) {
      return null;
    }

    return (
      <span styleName="text">
        {text}
      </span>
    );
  }

  render() {
    const { Button, name, size, iconClassName, className, dataHook } = this.props;
    const props = _.omit(this.props, 'intl', 'styles', 'settings', ..._.keys(IconButton.propTypes));

    const label = this.label;

    const styleNames = classnames('icon-button', {
      'icon-only': !label,
      generic: Button === GenericButton,
    });

    return (
      <Button {...props}
              styleName={styleNames}
              dataHook={dataHook}
              className={className}>
        <Icon name={name}
              size={size}
              styleName="icon"
              className={iconClassName} />
        {label}
      </Button>
    );
  }
}

export const TooltipIconButton = withTooltip(adaptShowStatePropsToClassName(IconButton));



// WEBPACK FOOTER //
// ./src/shared/components/button/icon/icon.js